<template>
  <div class="content">
    <h3>顺序码信息绑定查询</h3>
    <div class="item">
      <el-form id="form" ref="form" :inline="true" :model="form" label-width="90px">
        <el-form-item label="开始时间">
          <el-date-picker
						v-model="form.endtime" value-format="yyyy-MM-dd"
						type="date"
						placeholder="选择日期">
					</el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
						v-model="form.endtime" value-format="yyyy-MM-dd"
						type="date"
						placeholder="选择日期">
					</el-date-picker>
        </el-form-item>
        <el-form-item label="顺序码">
          <el-input placeholder="请输入" v-model="form.startvalue" clearble></el-input>
        </el-form-item>
      </el-form>
      <div class="btn">
        <el-button type="primary" @click="checkout">查 询</el-button>
        <el-button @click="checkout" type="warning">重 置</el-button>
      </div>
    </div>
    <div class="item">
			<el-table :data="tableData" border>
				<el-table-column prop="FactoryName" label="顺序码起始值"></el-table-column>
				<el-table-column prop="FactoryCode" label="顺序码终止值"></el-table-column>
				<el-table-column prop="Address" label="产品编号"></el-table-column>
        <el-table-column prop="Address" label="产品名称"></el-table-column>
        <el-table-column prop="Address" label="产地"></el-table-column>
				<el-table-column prop="Address" label="班次"></el-table-column>
        <el-table-column prop="Address" label="批次"></el-table-column>
        <el-table-column prop="Address" label="生产日期"></el-table-column>
        <el-table-column prop="Address" label="操作员"></el-table-column>
				<el-table-column prop="Address" label="创建时间"></el-table-column>
			</el-table>
      <el-pagination
			background
			@current-change="handleCurrentChange"
			layout="total,prev, pager, next,jumper"
			:total="pageNum"
			:page-size="10">
			</el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      dialogVisible2: false,
      deletevalue: null,
      num: null,
      form: {
        odd: "", //出库单号
        outstore: "", //出库库房
        outstate: "", //出库类型
        dealernum: "", //经销商编码
        dealer: "", //经销商
        radio: 1, //操作方式

        startvalue: "", //起始值
        endvalue: "", //终止值
        deletevalue: [], //删除码

        num: [], //顺序码

        remark: "", //备注
        check: true, //修改选项
        product: "", //产品名称
        productnum: "", //产品编号
        productfactory: "", //生产工厂
        production: "", //生产车间
        productionline: "", //生产线
        productionteam: "", //生产班组
        productionbatch: "", //产品批号
        supplier: "", //供应商
        qc: "", //质检员
        productiondate: "", //保质期
        pd: "", //生产日期
        expirationdate: "" //截止日期
      },
      options: [
        {
          value: "选项1",
          label: "创建时间"
        },
        {
          value: "选项2",
          label: "更新时间"
        }
      ],
      warehouse: [
        {
          value: "仓库1",
          label: "芬腾仓库"
        }
      ],
      outstock: [
        {
          value: "出库1",
          label: "销售出库"
        },
        {
          value: "出库2",
          label: "调拨出库"
        }
      ],
      gridData: [
        {
          id: "1",
          num: "FTtz1001",
          name: "广州市重光贸易有限公司"
        },
        {
          id: "2",
          num: "FT08001",
          name: "佛山市典华内衣实业有限公司"
        }
      ],
      current: null,
      tableData: []
    };
  },
  methods: {
    numDeletevalue(index) {
      console.log(index);
      this.form.num.splice(index, 1);
    },
    numChange(val) {
      this.form.num.push(this.num);
      this.num = null;
    },
    romoveDeletevalue(index) {
      console.log(index);
      this.form.deletevalue.splice(index, 1);
    },
    deletevalueChange(val) {
      this.form.deletevalue.push(this.deletevalue);
      this.deletevalue = null;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },

    confirm() {
      this.form.dealer = this.current.name;
      this.form.dealernum = this.current.num;
      this.dialogVisible = false;
    },
    confirm2() {
      this.form.product = this.current.name;
      this.form.productnum = this.current.num;
      this.dialogVisible2 = false;
    },
    handleCurrentChange(data) {
      this.current = data;
    },

    dealerfocus() {
      //	请求经销商数据
      this.$axios({
        method: "post",
        url: "/FW/getdealerfocus",
        data: {}
      }).then(res => {
        console.log(res);
        gridData = res;
      });
      this.dialogVisible = true;
    },

    checkout() {
      var user = JSON.parse(sessionStorage.getItem("user"));
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      var date = yy + "-" + mm + "-" + dd;
      console.log(this.form);
      this.$axios({
        method: "post",
        url: "/FW/OutStoreSeqCode.ashx",
        params: {
          //用户信息
          user: user,
          //表单信息
          dealer: this.form,
          //提交时间
          date: date
        }
      }).then(res => {
        console.log(res);
      });
    }
  }
};
</script>

<style scoped>
.title {
  text-align: left;
}
.btn {
  width: 500px;
  margin: 0px 90px;
}
.el-form--inline .el-form-item {
  width: 300px;
  margin-bottom: 10px;
}
.el-input,
.el-select {
  width: 200px;
}
.el-checkbox {
  line-height: 19px;
}
.el-radio {
  line-height: 16px;
}
.tag {
  margin: 0 70px;
}
.tag .el-tag {
  margin-left: 20px;
}
</style>
<style >
#form .el-upload-list {
  width: 900px !important;
}
#form .el-upload-list--picture .el-upload-list__item {
  width: 300px;
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/pages/BindCodeList.vue